import React from 'react';
import PropTypes from 'prop-types';
import ConditionalWrapperDivs from '../../HelperComponents/ConditionalWrapperDivs';
import { useAppStore } from '../../../stores';

import './FloorPlanImage.scss';

const FloorPlanImage = ({
  src,
  imgClassName,
  imgAlt,
  disclaimer,
  onImageLoad,
}) => {
  const settings = useAppStore((state) => state.settings);
  const { mode } = settings || {};
  const isPrint = mode === 'print';

  const handleLoad = () => {
    if (onImageLoad) {
      onImageLoad();
    }
  };

  return src && (
    <ConditionalWrapperDivs
      condition={isPrint}
      classNamesArray={['floorPlanImage']}
    >

      {/* This wrapper makes the image full height on print. */}
      <ConditionalWrapperDivs
        condition={isPrint}
        classNamesArray={['floorPlanImage__imageWrapper']}
      >

        <img
          className={imgClassName}
          src={src}
          alt={imgAlt}
          onLoad={handleLoad}
        />

      </ConditionalWrapperDivs>

      { isPrint && (
        <div className="floorPlanImage__disclaimer">
          { disclaimer }
        </div>
      )}

    </ConditionalWrapperDivs>
  );
};

FloorPlanImage.propTypes = {
  src: PropTypes.string,
  imgClassName: PropTypes.string,
  imgAlt: PropTypes.string.isRequired,
  disclaimer: PropTypes.string.isRequired,
  onImageLoad: PropTypes.func,
};

FloorPlanImage.defaultProps = {
  src: null,
  imgClassName: '',
  onImageLoad: null,
};

export default FloorPlanImage;
